/**
 * @overview History API helpers
 *
 * @module urlHelper
 */

/**
 * Push a record into the browser history.
 *
 * @param {object} stateData
 * @param {string} url
 * @param {string} title
 */
function pushHistory (stateData, url) {
    if (window.history.pushState && url.length > 0) {
        window.history.pushState(stateData, null, url);
    }
}

/**
 * Return a string containing querystring keys and values, optionally excluding certain values.
 *
 * @param {object} location
 * @param {string[]} keysToRemove
 * @returns {string}
 */
function removeQueryStringKeys (rawQueryString, keysToRemove = []) {
    if (rawQueryString && rawQueryString.length > 1) {
        const removeLeadingQuestionMark = qs => qs.startsWith('?') && qs.substr(1) || qs;
        const removeSpecifiedKeys = qs => !keysToRemove.some(val => qs.startsWith(val));
        const joinQuerystringValues = (acc, qs) => `${acc}${qs}&`;

        return removeLeadingQuestionMark(rawQueryString)
            .split('&')
            .filter(removeSpecifiedKeys)
            .reduce(joinQuerystringValues, '')
            .slice(0, -1);
    }

    return '';
}

export {
    pushHistory,
    removeQueryStringKeys
};
